import { Injectable } from '@angular/core';

/**
 * Per-browser flags for one-time informational onboarding flows.
 *
 * Both the read AND the write are guarded: `localStorage` can throw in Safari
 * private mode or on a quota error, and a throwing write must never block the
 * caller (the onboarding dialog is `disableClose: true`).
 */
@Injectable({ providedIn: 'root' })
export class OnboardingStorageService {
  private approvalDeadlineKey = 'approvalDeadlineOnboardingSeen';

  hasSeenApprovalDeadlineOnboarding(): boolean {
    try {
      return localStorage.getItem(this.approvalDeadlineKey) === 'true';
    } catch {
      return false;
    }
  }

  markApprovalDeadlineOnboardingSeen(): void {
    try {
      localStorage.setItem(this.approvalDeadlineKey, 'true');
    } catch {
      // The flag could not be persisted; the caller proceeds regardless.
    }
  }
}
